import ImageOptimizer from '@/components/image-optimizer';
import { ProcessCardProps } from '@/types/franchise.type';

export default function ProcessCard({
  idx,
  title,
  description,
}: ProcessCardProps) {
  const isLastItem = idx === 8; // 마지막 요소 확인

  return (
    <div className="relative">
      <div className="border-stroke-graylight desktop:w-[280px] desktop:pr-0 rounded-2xl border bg-white px-7 py-8 shadow-md">
        <div className="relative flex items-center justify-start gap-2">
          <span className="bg-main-yellow text-level-2 typo-16 flex size-6 items-center justify-center rounded-full font-bold">
            {idx}
          </span>
          <span className="typo-26 font-extrabold">{title}</span>
        </div>
        <p className="typo-20 text-level-4 pt-4 leading-relaxed font-semibold whitespace-pre-line">
          {description}
        </p>
      </div>

      {/* 화살표 - 마지막 요소가 아닐 때만 표시 */}
      {!isLastItem && (
        <div className="desktop:-right-3.5 desktop:left-2/2 desktop:top-1/2 desktop:-translate-y-1/2 desktop:rotate-270 absolute -bottom-3.5 left-1/2 flex size-7 -translate-x-1/2 items-center justify-center">
          <ImageOptimizer
            src="/images/icons/icon_bottom_arrow_circle.svg"
            alt=""
            fill
          />
        </div>
      )}
    </div>
  );
}
